export const routes = {
  ROOT: '/',
  UTM_ASANA: '/utm=asana',
  HOME: '/home',
  LOGIN: '/login',
  USER_REGISTER: '/user-register',
  CHORTKE: '/chortke',
  CHORTKE_UNFAIR_PRICE: '/chortke/unfair-price',
  CHORTKE_SHOW_ITEM: '/chortke/show/:nameSpace',
  SERVICES_AREA: '/services/service-area/:vendorId',
  PROFILE: '/profile/:vendorId',
  ORDERS: '/orders',
  ORDER_DETAILS: '/orders/:orderId',
  ORDER_STATUS: '/orders/:orderId/status',
  PROMOTION_CENTER: '/services/promotion-center',
  PROMOTION_CENTER_INFO: '/services/promotion-center/info',
  PROMOTION_CENTER_CAMPAIGN: '/services/promotion-center/campaign/:cycleId',
  PROMOTION_CENTER_DISCOUNT_VIEW: '/services/promotion-center/discount-view/:cycleId',
  PROMOTION_CENTER_PIN_LIST: '/services/promotion-center/pin-list',
  PROMOTION_CENTER_PIN_DETAILS: '/services/promotion-center/pin-details/:pinId',
  PROMOTION_CENTER_PIN_BUY_PACKAGE: '/services/promotion-center/pin-buy-package',
  PROMOTION_CENTER_PIN_BASKET: '/services/promotion-center/pin-basket',
  PROMOTION_CENTER_PIN_PAYMENT_SUCCESS: '/services/promotion-center/pin-payment-success',
  PROMOTION_CENTER_COUPON_LIST: '/services/promotion-center/coupon/list',
  PROMOTION_CENTER_COUPON_ADD: '/services/promotion-center/coupon/add',
  PROMOTION_CENTER_COUPON_DETAILS: '/services/promotion-center/coupon/details/:couponId',
  PROMOTION_CENTER_COUPON_PAYMENT_SUCCESS: '/services/promotion-center/coupon/payment/success',
  PROMOTION_CENTER_CUSTOM_DEAL: '/services/promotion-center/custom-deal',
  PROMOTION_CENTER_CUSTOM_DEAL_SELECT_PRODUCTS:
    '/services/promotion-center/custom-deal/select-products',
  PROMOTION_CENTER_CUSTOM_DEAL_APPLY_DISCOUNT:
    '/services/promotion-center/custom-deal/apply-discount/:dealId',
  PROMOTION_CENTER_CUSTOM_DEAL_SELECT_DATE:
    '/services/promotion-center/custom-deal/select-date/:dealId',
  PROMOTION_CENTER_CUSTOM_DEAL_DETAIL: '/services/promotion-center/custom-deal/detail/:dealId',
  PROMOTION_CENTER_PRO_LIST: '/services/promotion-center/pro/list',
  PROMOTION_CENTER_PRO_ADD: '/services/promotion-center/pro/add',
  PROMOTION_CENTER_PRO_DETAILS: '/services/promotion-center/pro/details/:vendorProId',
  PROMOTION_CENTER_PRO_PAYMENT_SUCCESS: '/services/promotion-center/pro/payment/success',
  PROMOTION_CENTER_EXTRA_DELIVERY_LIST: '/services/promotion-center/extra-delivery/list',
  PROMOTION_CENTER_EXTRA_DELIVERY_DETAILS:
    '/services/promotion-center/extra-delivery/details/:extraDeliveryId',
  PROMOTION_CENTER_EXTRA_DELIVERY_PAYMENT_SUCCESS:
    '/services/promotion-center/extra-delivery/payment/success',
  VENDOR_SCORE: '/vendor-score',
  TICKETS: '/tickets',
  NEW_TICKET: '/new_ticket',
  TICKET_DETAILS: '/ticket/:id',
  TRACKING: '/tracking',
  TRACKING_DETAILS: '/tracking/:id',
  VENDOR_REGISTER: '/vendor-register',
  VENDOR_REGISTER_OVERVIEW: '/vendor-register-overview',
  CPC_LIST: '/cpc/list',
  CPC_BUY_FLOW: '/cpc/buy/:step',
  CPC_PAYMENT_SUCCESS: '/cpc/payment-success',
  CPC_DETAILS: '/cpc/details/:id',
  FAQ: '/faq',
  NOTIFICATION_CENTER: '/notification-center',
  INVOICE: '/invoice',
  INVOICE_DETAILS: '/invoice/:id',
  PRODUCTS_LIST: '/products/list'
};
